<div class="sgt-menu">
  <button
    class="sgt-menu__trigger"
    (click)="toggleMenu()"
    type="button"
    #trigger
  >
    <ng-content select="[trigger]"></ng-content>
  </button>
</div>

<div
  *ngIf="isOpen"
  #menuContainer
  class="sgt-menu__list"
  [ngClass]="settings?.listClass"
  [class.sgt-menu__list--upward]="openUpward"
  (click)="onMenuClick($event)"
>
  <div *ngIf="settings?.hasHeader" class="sgt-menu__header">
    <ng-content select="[header]"></ng-content>
  </div>

  <div class="sgt-menu__items">
    <ng-content select="[items]"></ng-content>
  </div>

  <div *ngIf="settings?.hasFooter" class="sgt-menu__footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
